<template>
  <div>
  <el-dialog
    :visible.sync="visible"
    width="90%"
    top="3vh"
    append-to-body
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="stock-take-dialog"
  >
    <span slot="title">库存盘点单</span>
    <div class="dialog-body">
      <!-- 盘点单基本信息 -->
      <el-card class="nx-section-card" shadow="never">
        <div class="nx-card-header">
          <div class="nx-card-title">盘点单信息</div>
        </div>
        <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-width="96px"
          size="small"
        >
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="盘点单编号" prop="sheetNo">
                <el-input v-model="form.sheetNo" placeholder="自动生成" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点时间" prop="countTime">
                <el-date-picker
                  v-model="form.countTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点人" prop="counterName">
                <el-input v-model="form.counterName" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点煤棚" prop="stockCode">
                <el-select
                  v-model="form.stockCode"
                  filterable
                  clearable
                  placeholder="请选择"
                  style="width: 100%"
                  @visible-change="handleStockSelectVisible"
                  @change="handleStockChange"
                >
                  <el-option
                    v-for="item in stockOptions"
                    :key="item.id"
                    :label="item.storeName || item.storeNo"
                    :value="item.storeNo"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <!-- 汇总卡片 -->
      <el-card class="nx-section-card" shadow="never">
        <div class="summary-grid">
          <div class="summary-item">
            <div class="summary-label">当前总库存(吨)</div>
            <div class="summary-value">{{ formatNumber(summary.totalBook) }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">实盘数量(吨)</div>
            <div class="summary-value">{{ formatNumber(summary.totalActual) }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">差异(吨)</div>
            <div class="summary-value summary-value--diff">
              {{ formatDiff(summary.totalDiff) }}
            </div>
          </div>
          <div class="summary-item">
            <div class="summary-label">差异率(%)</div>
            <div class="summary-value summary-value--diff">
              {{ formatDiff(summary.totalDiffRate, true) }}
            </div>
          </div>
        </div>
      </el-card>

      <!-- 盘点明细表 -->
      <el-card class="nx-section-card" shadow="never">
        <div class="nx-card-header">
          <div class="nx-card-title">盘点明细</div>
          <div class="nx-card-extra">
            <el-button
              size="mini"
              type="primary"
              plain
              icon="el-icon-plus"
              :disabled="!form.stockCode || !form.mainStoreId"
              :loading="stacksLoading"
              @click="addContractedStacks"
            >
              添加堆位
            </el-button>
          </div>
        </div>
        <el-table
          class="stock-take-lines-table"
          :data="lineList"
          height="480px"
          size="mini"
          v-loading="linesLoading"
        >
          <el-table-column prop="locationCode" label="堆位编码" min-width="180" show-overflow-tooltip />
          <el-table-column prop="locationName" label="堆位名称" width="140" show-overflow-tooltip />
          <el-table-column prop="custName" label="货主" width="140" show-overflow-tooltip />
          <el-table-column prop="cargoNo" label="煤种编码" min-width="150" show-overflow-tooltip />
          <el-table-column prop="cargoName" label="煤种名称" min-width="150" show-overflow-tooltip />
          <el-table-column prop="bookWeight" label="账面(吨)" width="110">
            <template slot-scope="scope">
              {{ formatNumber(scope.row.bookWeight) }}
            </template>
          </el-table-column>
          <el-table-column prop="capacityLimit" label="容量上限(吨)" width="120">
            <template slot-scope="scope">
              {{ scope.row.capacityLimit != null ? formatNumber(scope.row.capacityLimit) : '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="actualWeight"
            label="实盘(吨)"
            width="150"
            class-name="stock-take-col-actual"
          >
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row._actualWeight"
                class="stock-take-actual-input"
                :min="0"
                :step="0.1"
                :precision="2"
                size="mini"
                controls-position="right"
                @change="recalcRow(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="差异(吨)" width="110">
            <template slot-scope="scope">
              <span
                :class="scope.row._diff > 0 ? 'diff-positive' : (scope.row._diff < 0 ? 'diff-negative' : '')"
              >
                {{ formatDiff(scope.row._diff) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="差异率(%)" width="110">
            <template slot-scope="scope">
              <span
                :class="scope.row._diffRate > 0 ? 'diff-positive' : (scope.row._diffRate < 0 ? 'diff-negative' : '')"
              >
                {{ formatDiff(scope.row._diffRate, true) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="diffReason" label="差异原因" min-width="180">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row._diffReason"
                size="mini"
                placeholder="请输入"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="72" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" class="nx-danger-text" @click="removeLine(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" :disabled="submitting" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submitting"
        @click="handleSubmit"
      >
        确 定
      </el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import {
  getNextSheetNo,
  getStoreSheds,
  getContractedStacks,
  submitSheet
} from '../api'

export default {
  name: 'StockTakeDialog',
  data() {
    return {
      visible: false,
      submitting: false,
      form: {
        sheetNo: '',
        countTime: '',
        counterName: '',
        stockCode: '',
        stockName: '',
        mainStoreId: null
      },
      rules: {
        sheetNo: [{ required: true, message: '请输入', trigger: 'blur' }],
        countTime: [{ required: true, message: '请选择', trigger: 'change' }],
        counterName: [{ required: true, message: '请输入', trigger: 'blur' }],
        stockCode: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      stockOptions: [],
      lineList: [],
      linesLoading: false,
      stacksLoading: false,
      summary: {
        totalBook: 0,
        totalActual: 0,
        totalDiff: 0,
        totalDiffRate: 0
      }
    }
  },
  methods: {
    open() {
      this.reset()
      this.visible = true
      this.fetchNextSheetNo()
      this.initDefaultTime()
      this.fetchStockShedOptions()
    },
    reset() {
      this.form = {
        sheetNo: '',
        countTime: '',
        counterName: '',
        stockCode: '',
        stockName: '',
        mainStoreId: null
      }
      this.lineList = []
      this.summary = {
        totalBook: 0,
        totalActual: 0,
        totalDiff: 0,
        totalDiffRate: 0
      }
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
    },
    initDefaultTime() {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const d = String(now.getDate()).padStart(2, '0')
      const hh = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      const ss = String(now.getSeconds()).padStart(2, '0')
      this.form.countTime = `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    },
    async fetchNextSheetNo() {
      try {
        const { data } = await getNextSheetNo()
        if (data && data.data && data.data.sheetNo) {
          this.form.sheetNo = data.data.sheetNo
        }
      } catch (e) {
        // ignore
      }
    },
    async handleStockSelectVisible(visible) {
      if (!visible || this.stockOptions.length) return
      await this.fetchStockShedOptions()
    },
    async fetchStockShedOptions() {
      try {
        const { data } = await getStoreSheds()
        this.stockOptions = (data && data.data) || []
      } catch (e) {
        this.stockOptions = []
      }
    },
    handleStockChange() {
      const target = this.stockOptions.find((i) => i.storeNo === this.form.stockCode)
      this.form.stockName = target ? target.storeName : ''
      this.form.mainStoreId = target && target.id != null ? target.id : null
      this.lineList = []
      this.summary = {
        totalBook: 0,
        totalActual: 0,
        totalDiff: 0,
        totalDiffRate: 0
      }
    },
    /** 由已签约堆位生成明细行（不拉取账面接口，提交时由后端按盘点日解析 stock_management） */
    wrapLineRowFromStack(stack) {
      const book = stack.bookWeight != null ? Number(stack.bookWeight) : 0
      const cap =
        stack.capacityLimit != null && stack.capacityLimit !== ''
          ? Number(stack.capacityLimit)
          : null
      const varNo = stack.varNo != null && stack.varNo !== '' ? String(stack.varNo) : ''
      const varName = stack.varName != null && stack.varName !== '' ? String(stack.varName) : ''
      return {
        stockManagementId: null,
        locationCode: stack.locationCode,
        locationName: stack.locationName,
        custName: stack.custName || '',
        custNo: '',
        cargoNo: varNo,
        cargoName: varName || '-',
        varNo,
        varName,
        bookWeight: book,
        capacityLimit: cap != null && !Number.isNaN(cap) ? cap : null,
        contractExtId: stack.contractExtId,
        storeSubId: stack.storeSubId,
        stockCode: this.form.stockCode,
        stockName: this.form.stockName,
        _actualWeight: book,
        _diff: 0,
        _diffRate: 0,
        _diffReason: ''
      }
    },
    async addContractedStacks() {
      if (!this.form.mainStoreId) {
        this.$message.warning('请先选择盘点煤棚')
        return
      }
      this.stacksLoading = true
      try {
        const { data } = await getContractedStacks(this.form.mainStoreId)
        const list = (data && data.data) || []
        if (!list.length) {
          this.$message.warning('该煤棚下暂无已签约堆位')
          return
        }
        let added = 0
        for (const stack of list) {
          if (!stack.locationCode) continue
          const dup = this.lineList.some(
            (r) =>
              r.locationCode === stack.locationCode &&
              String(r.contractExtId != null ? r.contractExtId : '') ===
                String(stack.contractExtId != null ? stack.contractExtId : '')
          )
          if (dup) continue
          const row = this.wrapLineRowFromStack(stack)
          this.lineList.push(row)
          this.recalcRow(row, false)
          added++
        }
        this.recalcSummary()
        if (added > 0) {
          this.$message.success(`已添加 ${added} 条堆位明细，可删除不需要的行`)
        } else {
          this.$message.warning('当前明细已包含全部已签约堆位')
        }
      } catch (e) {
        // 全局 axios 已提示
      } finally {
        this.stacksLoading = false
      }
    },
    removeLine(index) {
      this.lineList.splice(index, 1)
      this.recalcSummary()
    },
    /** 账面、实盘是否不一致（按两位小数比较） */
    rowAmountsDiffer(book, actual) {
      const b = Number(Number(book || 0).toFixed(2))
      const a = Number(Number(actual || 0).toFixed(2))
      return a !== b
    },
    /** 差异率%：账面为 0 且实盘&gt;0 时为 100% */
    diffRatePercent(book, diff) {
      const b = Number(book || 0)
      const d = Number(diff || 0)
      if (Number.isNaN(b) || b === 0) {
        return d > 0 ? 100 : 0
      }
      return (d / b) * 100
    },
    recalcRow(row, updateSummary = true) {
      const book = Number(row.bookWeight || 0)
      const actual = Number(row._actualWeight || 0)
      const diff = actual - book
      const rate = this.diffRatePercent(book, diff)
      row._diff = Number.isNaN(diff) ? 0 : Number(diff.toFixed(2))
      row._diffRate = Number.isNaN(rate) ? 0 : Number(rate.toFixed(2))
      if (updateSummary) {
        this.recalcSummary()
      }
    },
    recalcSummary() {
      let totalBook = 0
      let totalActual = 0
      this.lineList.forEach((row) => {
        const book = Number(row.bookWeight || 0)
        const actual = Number(row._actualWeight || 0)
        totalBook += book
        if (!Number.isNaN(actual)) totalActual += actual
      })
      const diff = totalActual - totalBook
      const rate = this.diffRatePercent(totalBook, diff)
      this.summary.totalBook = Number(totalBook.toFixed(2))
      this.summary.totalActual = Number(totalActual.toFixed(2))
      this.summary.totalDiff = Number(diff.toFixed(2))
      this.summary.totalDiffRate = Number(rate.toFixed(2))
    },
    /** 提交前按当前堆位 stock_amount 刷新账面，与后端盘点口径一致（不依赖打开页面时的缓存） */
    async syncLineBookFromStacks() {
      if (!this.form.mainStoreId || !this.lineList.length) return
      const { data } = await getContractedStacks(this.form.mainStoreId)
      const list = (data && data.data) || []
      const map = new Map()
      for (let i = 0; i < list.length; i++) {
        const s = list[i]
        if (!s.locationCode) continue
        const k = `${s.locationCode}\t${s.contractExtId != null ? String(s.contractExtId) : ''}`
        const bw = s.bookWeight != null && s.bookWeight !== '' ? Number(s.bookWeight) : 0
        map.set(k, Number.isNaN(bw) ? 0 : bw)
      }
      for (let j = 0; j < this.lineList.length; j++) {
        const row = this.lineList[j]
        if (!row.locationCode) continue
        const k = `${row.locationCode}\t${row.contractExtId != null ? String(row.contractExtId) : ''}`
        if (map.has(k)) {
          row.bookWeight = map.get(k)
          this.recalcRow(row, false)
        }
      }
      this.recalcSummary()
    },
    async handleSubmit() {
      if (!this.lineList.length) {
        this.$message.warning('请先填写盘点明细')
        return
      }
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.submitting = true
        try {
          await this.syncLineBookFromStacks()
          const lines = []
          for (const row of this.lineList) {
          const book = Number(row.bookWeight || 0)
          const actual = Number(row._actualWeight)
          if (Number.isNaN(actual)) {
            this.$message.warning('请输入实盘数量')
            return
          }
          if (book === 0 && actual <= 0) {
            this.$message.warning(
              `堆位 ${row.locationCode || ''} 账面为0时，实盘吨数须大于0`
            )
            return
          }
          if (this.rowAmountsDiffer(book, actual)) {
            const reason = (row._diffReason || '').trim()
            if (!reason) {
              this.$message.warning(
                `堆位 ${row.locationCode || ''} 实盘与账面不一致，请填写差异原因`
              )
              return
            }
          }
          const line = {
            actualWeight: actual,
            diffReason: row._diffReason || ''
          }
          if (row.stockManagementId != null) {
            line.stockManagementId = row.stockManagementId
          } else {
            line.locationCode = row.locationCode
            if (row.contractExtId != null) {
              line.contractExtId = row.contractExtId
            }
          }
          lines.push(line)
          }
          const payload = {
            sheetNo: this.form.sheetNo,
            countTime: this.form.countTime,
            counterName: this.form.counterName,
            stockCode: this.form.stockCode,
            stockName: this.form.stockName,
            lines
          }
          await submitSheet(payload)
          this.$message.success('盘点单提交成功')
          this.visible = false
          this.$emit('success')
        } finally {
          this.submitting = false
        }
      })
    },
    formatNumber(val) {
      if (val === null || val === undefined || Number.isNaN(Number(val))) return '0'
      return Number(val).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDiff(val, isPercent = false) {
      if (val === null || val === undefined || Number.isNaN(Number(val))) return isPercent ? '0.00%' : '0.00'
      const num = Number(val)
      const fixed = num.toFixed(2)
      if (isPercent) {
        return `${fixed}%`
      }
      return fixed
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/nx-tokens.scss';

.stock-take-dialog .nx-danger-text {
  color: #f56c6c;
}

.stock-take-dialog .el-dialog__body {
  padding-top: 8px;
}

.dialog-body {
  max-height: 78vh;
  overflow: auto;
}

.summary-grid {
  display: flex;
  flex-wrap: wrap;
  gap: $nx-space-4;
}

.summary-item {
  flex: 1 1 160px;

  .summary-label {
    font-size: 12px;
    color: $nx-color-text-2;
    margin-bottom: $nx-space-1;
  }

  .summary-value {
    font-size: 18px;
    font-weight: 600;
    color: $nx-color-text-1;

    &.summary-value--diff {
      color: #ef4444;
    }
  }
}

.diff-positive {
  color: #10b981;
}

.diff-negative {
  color: #ef4444;
}

// 全局 .el-table__cell { height: 60px } 会裁切单元格内输入框；本表改为自适应行高
.stock-take-dialog ::v-deep .stock-take-lines-table.el-table {
  .el-table__body .el-table__cell {
    height: auto;
    min-height: 48px;
    vertical-align: middle;
  }

  .el-table__body .el-table__cell .cell {
    overflow: hidden;
    line-height: normal;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  td.stock-take-col-actual .cell {
    padding: 4px 6px;
    overflow: visible;
  }

  .stock-take-actual-input {
    width: 100%;
    max-width: 100%;
  }
}

</style>

